module.exports = __webpack_public_path__ + "media/assets/images/blog/short_week-small-f1d05782e44ce642ab55cdc663c2a843.png";